<template>
    <ul v-if="showSearchResults" class="search-results">
        <li v-for="(item, id) in items"
            :class="{active: id === activeItemId}"
            @click.stop="selectItem(item)">{{ item }}
        </li>
    </ul>
</template>

<script>
    export default {
        name: 'SearchResults',
        props: {
            items: {
                type: Array,
                default: [],
            },
            eventListenerId: {
                type: String,
                default: null,
                required: true,
            },
            opened: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                focused: false,
                keyPressed: false,
                activeItemId: 0,
            };
        },
        computed: {
            showSearchResults() {
                // return this.items.length;
                return this.items.length && this.focused;
                // return true;
                // return this.items.length && this.focused && this.keyPressed;
            }
        },
        mounted() {
            this.setListeners();
        },
        beforeDestroy() {
            this.removeListeners();
        },
        methods: {
            selectItem(item) {
                this.$emit('selected', item);
                this.keyPressed = false;
            },
            setListeners() {
                const element = document.getElementById(this.eventListenerId);

                element.addEventListener('focus', (event) => {
                    this.focused = true;
                });

                element.addEventListener('blur', (event) => {
                    setTimeout(() => {
                        this.keyPressed = false;
                        this.focused = false;
                    }, 300);
                });

                element.addEventListener('keydown', e => {
                    switch (e.key) {
                        case 'Enter':
                            this.keyEnter();
                            break;
                        case 'ArrowUp':
                            this.keyUp();
                            break;
                        case 'ArrowDown':
                            this.keyDown();
                            break;
                        default:
                            break;
                    }

                    if (!['Enter', 'Space', 'Backspace'].includes(e.key)) {
                        this.keyPressed = true;
                    }
                });
            },
            removeListeners() {
                const element = document.getElementById(this.eventListenerId);

                if (element) {
                    element.removeEventListener('focus');
                    element.removeEventListener('blur');
                    element.removeEventListener('keydown');
                }
            },
            keyUp() {
                if (this.activeItemId > 0) {
                    this.activeItemId -= 1;
                } else {
                    this.activeItemId = this.items.length - 1;
                }
            },
            keyDown() {
                if (this.activeItemId < this.items.length - 1) {
                    this.activeItemId += 1;
                } else {
                    this.activeItemId = 0;
                }
            },
            keyEnter() {
                if (this.showSearchResults) {
                    this.selectItem(this.items[this.activeItemId])
                }
            },
        },
    };
</script>
